import React from 'react'
import { useState } from "react";
import { FaArrowLeft, FaRegCommentDots, FaTimesCircle, FaThermometerHalf } from "react-icons/fa";
import clck from '../../assets/svg/clock.svg'
import len from '../../assets/svg/lentra.svg'
import profile from '../../assets/svg/profile.svg'
import production from '../../assets/svg/production.svg'
import mobile from '../../assets/svg/mobile.svg'
import location from '../../assets/svg/location.svg'
import abilash from '../../assets/svg/abilash.svg'
import saran from '../../assets/svg/saran.svg'
import santhosh from '../../assets/svg/santhosh.svg'
import meenaktchi from '../../assets/svg/meenaktchi.svg'
import ship from '../../assets/svg/ship.svg'
function Courierview() {
  const [activeTab, setActiveTab] = useState("items");
  const itemsData = [
    {
      itemName: "Laptop",
      quantity: 2,
      description:
        "ThinkPad Series - Business-oriented, durable, and known for its excellent keyboards",
    },
    {
      itemName: "Laptop",
      quantity: 2,
      description:
        "ThinkPad Series - Business-oriented, durable, and known for its excellent keyboards. IdeaPad Series - Budget-friendly and ideal for everyday ",
    },
  ];

  const guestsData = [
    {

      name: "Abilash Zibrahim",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: abilash
    },
    {
      name: "Saran Kumar",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: saran
    },
    {
      name: "Santhosh Kumar",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: santhosh
    },
    {
      name: "Meenakchi Sundaram",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: meenaktchi
    },
  ];
  return (
    <div style={{ fontFamily: "Epilogue", padding: "20px", backgroundColor: "#f5f5f5" }}>

      {/* Header Section */}
      <div style={{ display: "flex", flexDirection: "column", padding: "10px 20px", backgroundColor: "#fff", borderRadius: "8px" }}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
          {/* Left Section: Back Button, Profile Icon, Name, Company */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaArrowLeft style={{ fontSize: "18px", marginRight: "15px", cursor: "pointer" }} />
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: "35px", height: "35px", backgroundColor: "#2d3748", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "bold", marginRight: "10px" }}>J</div>
              <div>
                <h2 style={{ margin: "2px 0px", fontSize: "20px", fontWeight: "bold" }}>Jeason Statham</h2>
                <p style={{ color: "#555", display: "flex", alignItems: "center", fontSize: "13px", margin: "2px 0px", fontWeight: "500" }}>
                  <img src={len} alt="" /> Ship Rocket
                </p>
              </div>
            </div>

          </div>

          {/* Right Section: QR Code & Acknowledgement Buttons */}
          <div style={{ display: "flex", gap: "10px" }}>

            <button style={{ display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #ddd", padding: "8px 12px", borderRadius: "12px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }}>
              <FaRegCommentDots style={{ marginRight: "5px" }} /> Acknowledgement
            </button>
          </div>
        </div>


        {/* Gate-in, Duration, and Gate-out Section */}
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px dotted #ddd",
            padding: "10px",
            borderRadius: "20px",
            position: "relative",
          }}
        >
          {/* Gate In */}
          <div
            style={{
              border: "dashed 2px black",
              backgroundColor: "#fff",
              padding: "5px 15px",
              borderRadius: "20px",
              fontSize: "14px",
              fontWeight: "400",
              display: "flex",
              alignItems: "center",
              position: "relative",
              zIndex: 2,
            }}
          >
            Gate in :{" "}
            <span style={{ fontWeight: "600", marginLeft: "5px" }}>
              23 Feb 2025 at 05:05 PM
            </span>
          </div>

          {/* Dashed Connecting Line */}
          <div
            style={{
              flexGrow: 1,
              height: "2px",
              borderTop: "2px dashed black",
              margin: "0 10px",
              position: "relative",
              top: "0px",
              zIndex: 1,
            }}
          ></div>

          {/* Time Duration */}
          <div
            style={{
              backgroundColor: "#f0fff0",
              padding: "5px 15px",
              borderRadius: "20px",
              fontSize: "14px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              border: "1px solid #a3d9a5",
              position: "relative",
              zIndex: 2,
            }}
          >
            <img src={clck} alt="" /> 00:30:48
            hrs
          </div>

          {/* Dashed Connecting Line */}
          <div
            style={{
              flexGrow: 1,
              height: "2px",
              borderTop: "2px dashed black",
              margin: "0 10px",
              position: "relative",
              top: "0px",
              zIndex: 1,
            }}
          ></div>

          {/* Gate Out */}
          {
            activeTab === 'items'
              ? <button
                style={{
                  border: "dashed 2px black",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  padding: "8px 20px",
                  borderRadius: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 2
                }}
              >
                Received
              </button>
              :
              <button style={{
                border: "dashed 2px black",
                backgroundColor: "#4caf50",
                color: "#fff",
                padding: "8px 20px",
                borderRadius: "20px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                position: "relative",
                zIndex: 2
              }}>gate out:23 Feb 2025 at 05:05 PM</button>
          }
        </div>

      </div>


      <div style={{ display: "flex", fontWeight: "500" }}>
        {/* Visitor Details Section */}
        {
          activeTab === 'items'
            ? <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#fff", borderRadius: "8px", width: "700px", height: "889px" }}>
              <h3 style={{ marginBottom: "5px", fontSize: "16px", fontWeight: "700" }}>Person Details</h3>
              <p><img src={ship} alt="" /> Ship Rocket</p>
              <p><img src={mobile} alt="" /> +91-9876543210 - <span style={{ backgroundColor: "#F1F2F4", color: "black", padding: "5px 10px", borderRadius: "8px", border: "none", fontSize: "12px", }}>Personal</span></p>
              <p><img src={mobile} alt="" /> +91-9876543210 - <span style={{ backgroundColor: "#F1F2F4", color: "black", padding: "5px 10px", borderRadius: "8px", border: "none", fontSize: "12px", }}>Company</span></p>


              <p><img src={location} alt="" /> Chennai</p>

            </div>
            :
            <div style={{ width: "700px" }}></div>

        }


        {/* Right side container */}
        <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "20px", marginLeft: "10px", maxWidth: "75%", maxHeight: "fit-content" }}>

          {/* Box 1 */}
          <div
            style={{
              borderRadius: "12px",
              padding: "24px",
              width: "300px",
              fontFamily: "Inter, sans-serif",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                margin: "0 0 16px 0",
                color: "#0F172A",
                fontWeight: "700",
                fontSize: "16px",
                textAlign: "left"
              }}
            >
              Whom received
            </h4>

            {/* Profile Section */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <img
                src={profile}
                alt="Emilia Jackson"
                style={{
                  borderRadius: "50%",
                  width: "64px",
                  height: "64px",
                  objectFit: "cover",
                }}
              />
              <p
                style={{
                  margin: "0",
                  fontWeight: "700",
                  color: "#0F172A",
                  fontSize: "18px",
                }}
              >
                Emilia Jackson
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "14px",
                  color: "#64748B",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <img src={production} alt="" style={{ width: "16px", height: "16px" }} /> UXUI design
              </p>
            </div>
          </div>
          {/* Box 2 */}
          <div
            style={{
              borderRadius: "12px",
              padding: "20px",
              width: "350px",
              fontFamily: "Inter, sans-serif",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h4
              style={{
                margin: "0 0 12px 0",
                color: "#0F172A",
                fontWeight: "700",
                fontSize: "16px",
                textAlign: "left",
              }}
            >
              Address details
            </h4>

            {/* From Address */}
            <p
              style={{
                margin: "0 0 6px 0",
                fontSize: "12px",
                color: "#64748B",
                fontWeight: "500",
                textAlign: "left",
              }}
            >
              From address
            </p>
            <p
              style={{
                margin: "0 0 12px 0",
                fontSize: "13px",
                color: "#172B4D",
                fontWeight: "400",
                lineHeight: "1.5",
                textAlign: "left",
              }}
            >
              G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600091
            </p>

            {/* To Address */}
            <p
              style={{
                margin: "0 0 6px 0",
                fontSize: "12px",
                color: "#64748B",
                fontWeight: "400",
                textAlign: "left",
              }}
            >
              To address
            </p>
            <p
              style={{
                margin: "0",
                fontSize: "13px",
                color: "#172B4D",
                fontWeight: "400",
                lineHeight: "1.5",
                textAlign: "left",
              }}
            >
              G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600091
            </p>
          </div>
          {/* Box 3 */}
          <div
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "16px",
              padding: "16px",
              width: "322.67px",
              flexBais: "32%",
              fontFamily: "Arial, sans-serif",
              backgroundColor: "#fff",

            }}
          >
            <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Check list</h4>
            <div
              style={{
                backgroundColor: "#ffeeee",
                padding: "10px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px",
              }}
            >
              <FaTimesCircle style={{ color: "red" }} />
              <span style={{ fontWeight: "600", color: "#172B4D" }}>Druken</span>
            </div>
            <div
              style={{
                backgroundColor: "#ffeeee",
                padding: "10px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px",
              }}
            >
              <FaTimesCircle style={{ color: "red" }} />
              <span style={{ fontWeight: "600", color: "#172B4D" }}>Have a weapon</span>
            </div>
            <div
              style={{
                backgroundColor: "#ffeeee",
                padding: "10px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FaThermometerHalf style={{ color: "green" }} />
              <span style={{ fontWeight: "400", color: "#172B4D" }}>Temperature - <span style={{ fontWeight: "600", color: "#172B4D" }}>37°C</span> </span>
            </div>
          </div>
          {/* table data */}
          <div
            style={{
              backgroundColor: "#FFFFFF",
              padding: "20px 30px",
              borderRadius: "10px",
              flexBasis: "100%",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <h4
              style={{
                margin: "0 0 10px 0",
                color: "#0F172A",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              Item inside the parcel
            </h4>

            <p
              style={{
                margin: "0",
                color: "#475569",
                fontSize: "13px",
                fontWeight: "400",
                lineHeight: "1.5",
              }}
            >
              Thank you for registering your visit. Your check-in details have been successfully recorded.
              Please proceed to the reception for further assistance.
            </p>
          </div>

        </div>
      </div>

    </div>






  )
}

export default Courierview;